import React, { useState, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { HashRouter } from 'react-router-dom';
import { matchPath } from 'react-router';
import Body from './Body';
import Item from './ItemWrapper';
import Menu from './Menu';
import Submenu from './Submenu';
import SidebarContext from './SidebarContext';

/*
se delego Sidebar a determina il componente attivo,
ricavo i link dai children e scelgo quello con lunghezza maggiore.
PER ORA NON NECESSARIO

function isLinkActive(link, pathname) {
  if (link === '/') return false;
  return link === pathname || matchPath(pathname, { path: link, exact: false, strict: false });
}

function getLinksInTree(children, links = []) {
  if (children) {
    return React.Children.toArray(children).reduce((acc, child) => {
      const result = [...acc];
      if (child.props && child.props.link) result.push(child.props.link);
      return getLinksInTree(child.props && child.props.children, result);
    }, links);
  }
  return links;
}

...

  const isActive = useCallback((link, pathname) => {
    if (!isLinkActive(link, pathname)) {
      return false;
    }
    // di tutti i link con match, il corrente è quello più lungo!
    const r = links.reduce((max, l) => {
      if (l.length > max && isLinkActive(l, pathname)) return l.length;
      return max;
    }, -1);
    return r === link.length;
  }, [links]);
...
*/

export const SidebarImpl = ({ open, children, className }) => {
  const [openInternal, setOpen] = useState(open);
  const toggle = () => setOpen(!openInternal);
  const classes = useMemo(() => cns(
    'sidebar',
    {
      'sidebar--open': open,
    },
    className,
  ), [open, className]);

  return (
    <SidebarContext.Provider value={{
      openCallback: toggle,
      open: openInternal,
    }}
    >
      <div className={classes}>
        {children}
      </div>
    </SidebarContext.Provider>
  );
};

SidebarImpl.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /** Indica se mostrare inizialmente lo slidebar aperto */
  open: PropTypes.bool,
};

SidebarImpl.defaultProps = {
  children: null,
  className: '',
  open: false,
};

/**
Il componente Sidebar permette di disegnare una sidebar con degli elementi di menu opzionalmente annidati.
 */
const Sidebar = ({ open, children, className }) => (
  <HashRouter>
    <SidebarImpl open={open} className={className}>{children}</SidebarImpl>
  </HashRouter>
);

Sidebar.Body = Body;

Sidebar.Item = Item;

Sidebar.Menu = Menu;

Sidebar.Submenu = Submenu;

Sidebar.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /** Indica se mostrare inizialmente lo slidebar aperto */
  open: PropTypes.bool,
};

Sidebar.defaultProps = {
  children: null,
  className: '',
  open: false,
};

export default Sidebar;
